import {Tabs} from './tabs';
import {ReadyProvider} from '../../../application/providers/readyProvider';
import {OfferClickManager} from '../offer/offerClickManager';
import {FinOfferClickManager} from '../financialOffer/finOfferClickManager';
import {SubscriptionForm} from '../subscription/subscriptionForm';
import OfferViewFacade from '../offer/offerViewFacade';
import {addDelegateEventListener} from '../../../application/helpers';

ReadyProvider.executeOnReady(() => {
    let tabsContent = document.querySelector('[data-content="tabs"]'),
        moreHome = document.querySelector('[data-content="more-home"]');

    new Tabs(tabsContent);
    OfferClickManager.init(tabsContent);
    FinOfferClickManager.init(tabsContent);
    OfferViewFacade.notifyAboutAllAvailable(tabsContent);

    if (moreHome) {
        moreHome.addEventListener('click', (event) => {
            event.preventDefault();
            let buttonElement = event.currentTarget,
                showCodes = Number(buttonElement.getAttribute('data-show-count')),
                displayedCodes = Number(buttonElement.getAttribute('data-displayed')),
                totalCodes = Number(buttonElement.getAttribute('data-total'));

            displayedCodes += showCodes;
            buttonElement.setAttribute('data-displayed', displayedCodes);
            Array.from(document.querySelectorAll('.home-hide-code')).slice(0, showCodes).forEach((element) => {
                element.classList.remove('home-hide-code');
            });

            if (displayedCodes >= totalCodes) {
                return buttonElement.remove();
            }

            buttonElement.querySelector('[data-content="count-left"]').textContent = String(totalCodes - displayedCodes);
        });
    }

    let buttonHowItWorks = document.querySelector('[data-toggle="how-it-works"]');

    if (buttonHowItWorks) {
        buttonHowItWorks.addEventListener('click', (event) => {
            event.preventDefault();
            document.querySelector('[data-block="how-it-works"]').classList.toggle('hiw-closed');
        });
    }

    new SubscriptionForm(document.querySelector('[data-subsctiption="form"]'));

    addDelegateEventListener(
        document.querySelector('[data-block="home-faq"]'),
        'click',
        '[data-action="toggle-answer"]',
        (buttonElement, event) => {
            event.preventDefault();
            buttonElement.classList.toggle('active');

            let faqItem = buttonElement.closest('[data-block="faq-item"]');
            faqItem.querySelector('[data-block="answer"]').classList.toggle('d-none');
        }
    );
});
